exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color-editor *[data-v-94028992] {\n  width: 100%;\n}\n.color-picker[data-v-94028992] {\n  margin-top: 0.5rem;\n}\n", ""]);

// exports
